// src/utils/authHelpers.js

// Checks whether the email-gate has already been “unlocked” in localStorage
export const isUnlocked = () => {
  return localStorage.getItem('ee-email-gate') === 'true';
};

// Marks the email-gate as “unlocked” in localStorage
export const setUnlocked = () => {
  localStorage.setItem('ee-email-gate', 'true');
};

// (Optional) Checks whether the tooltip has already been shown
export const hasSeenTooltip = () => {
  return localStorage.getItem('ee-tooltip-shown') === 'true';
};

// (Optional) Marks the tooltip as “shown” in localStorage
export const markTooltipShown = () => {
  localStorage.setItem('ee-tooltip-shown', 'true');
};
